import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Sticky } from "../../../types";
import { toast } from "react-toastify";
import { IAuthResponse } from "../auth/IAuthState";
import { createSticky, fetchSticky, updateSticky } from "./stickyAsyncThunk";
import { RequestResults } from "../../common/RequestStatus";

export interface DeleteSticky extends IAuthResponse {
  id: string;
}

interface StickyState {
  data: Sticky[];
  status: RequestResults;
  loading: boolean;
  error: string | null;
}

const initialState: StickyState = {
  data: [],
  status: RequestResults.idle,
  loading: false,
  error: null,
};

// Slice
const stickySlice = createSlice({
  name: "sticky",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSticky.pending, (state) => {
        state.status = RequestResults.pending;
        state.error = null;
      })
      .addCase(fetchSticky.fulfilled, (state, action: PayloadAction<Sticky[]>) => {
        state.status = RequestResults.success;
        state.data = action.payload;
      })
      .addCase(fetchSticky.rejected, (state, action) => {
        state.status = RequestResults.failed;
        toast.error(action.payload || "Failed to fetch Escalate");
        state.error = action.payload || "Failed to fetch Escalate";
      });
    builder
      .addCase(createSticky.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSticky.fulfilled, (state, action: PayloadAction<Sticky>) => {
        state.loading = false;
        state.data.push(action.payload);
      })
      .addCase(createSticky.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload || "Failed to add Escalate");
        state.error = action.payload || "Failed to add Escalate";
      });
    builder
      .addCase(updateSticky.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateSticky.fulfilled, (state, action: PayloadAction<Sticky>) => {
        const index = state.data.findIndex((item) => item.id === action.payload.id);
        if (index !== -1) {
          state.data[index] = action.payload;
        }
        state.loading = false;
      })
      .addCase(updateSticky.rejected, (state, action) => {
        state.loading = false;
        toast.error(action.payload || "Failed to update Sticky");
        state.error = action.payload || "Failed to update Sticky";
      });
  },
});

export const selectStickys = (state: RootState) => state.sticky;

export default stickySlice.reducer;
